import React, { useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import ReactGA from 'react-ga4';
import { initializeGTM, trackPageView } from './utils/gtm';
import './App.css';
import Loader from './components/Loader';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import MenuShowcase from './components/MenuShowcase';
import Process from './components/Process';
import Trust from './components/Trust';
import CTA from './components/CTA';
import Footer from './components/Footer';
import HomeSEO from './components/SEO/HomeSEO';

// Replace 'G-XXXXXXXXXX' with your actual GA4 Measurement ID
const GA4_MEASUREMENT_ID = 'G-ZSYDTNN51L';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  // GA4: Initialize Google Analytics for all environments
  useEffect(() => {
    ReactGA.initialize(GA4_MEASUREMENT_ID);
    
    // Track initial page view
    ReactGA.send({ 
      hitType: "pageview", 
      page: window.location.pathname + window.location.search,
      title: document.title 
    });
    
    // Track custom event for app load
    ReactGA.event({
      category: 'engagement',
      action: 'app_load',
      label: 'home_page'
    });
  }, []);

  // GTM: Initialize tracking (keeping your existing implementation)
  useEffect(() => {
    initializeGTM();
    trackPageView('Home');
  }, []);

  // Track when loading completes
  useEffect(() => {
    if (!isLoading) {
      ReactGA.event({
        category: 'user_experience',
        action: 'page_loaded',
        label: 'home_page_complete',
        value: 1
      });
    }
  }, [isLoading]);

  // Handle body classes for loading state
  useEffect(() => {
    if (isLoading) {
      document.body.classList.add('loading');
    } else {
      document.body.classList.remove('loading');
    }

    return () => {
      document.body.classList.remove('loading');
    };
  }, [isLoading]);

  // Handle page loading
  useEffect(() => {
    const handleLoad = () => {
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
      return () => window.removeEventListener('load', handleLoad);
    }
  }, []);

  useEffect(() => {
    const maxLoadTime = setTimeout(() => {
      setIsLoading(false);
    }, 4000);

    return () => clearTimeout(maxLoadTime);
  }, []);

  return (
    <>
      {isLoading && <Loader />}
      
      <div className={`app-content ${isLoading ? 'loading' : 'loaded'}`}>
        <HelmetProvider>
          <HomeSEO />
          <Header />
          <Hero />
          <Features />
          <MenuShowcase />
          <Process />
          <Trust />
          <CTA />
          <Footer />
        </HelmetProvider>
      </div>
    </>
  );
}

export default App;
